const piniaStore = Pinia.createPinia()
piniaStore.use(PiniaPersist.createPersistPlugin())

const useCsbStore = Pinia.defineStore('csb', {
  state() {
    return {
      token: '173115e0ffff1694f2761335c8d6b34b',
      sitehost: window.location.origin,
      groupsLastLoaded: null,
      groups: null,
      currentModel: null,
      loading: false
    }
  },
  actions: {
    async init() {
      if (!this.loading && (this.groups == null || (this.groupsLastLoaded != null && Date.now() - this.groupsLastLoaded > 86400000))) { // 86400000 milliseconds = 1 day
        this.loading = true
        await this.loadGroups()
      }
    },
    async loadGroups(startCursor = null, current = []) {        
      var response = await fetch(this.sitehost + '/api/graphql.json', {
        method: "post",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": this.token
        },
        body: `query getGroups { metaobjects(type: "groups", first: 25, ` + 
          (startCursor == null ? '': 'after: "' + startCursor + '"') + 
          ` ) {
            nodes{
              id,
              type,
              name: field(key: "name") { value },
              brand: field(key: "brand") { reference { 
                ... on Metaobject {
                  id
                  name: field(key: "name") { value }
                } 
              } },
              group: field(key: "group") { value },
              sub_group: field(key: "sub_group") { value },
              models: field(key: "models") { value },
              chain_spec: field(key: "chain_spec") { value },
              collection: field(key: "collection") { reference { 
                ... on Collection {
                  id
                  handle
                  image {
                    url
                  }
                }
              } }
            },
            pageInfo {
              hasNextPage,
              endCursor
            }
          }
        }`
      })
        
      var render = await response.json()
      Array.prototype.push.apply(current, render.data.metaobjects.nodes.map((item) => { return {
        name: item.name.value,
        brand: {
          id: item.brand.reference.id,
          name: item.brand.reference.name.value
        },
        group: item.brand.reference.name.value + ' - ' + item.group.value,
        sub_group: item.brand.reference.name.value + ' - ' + item.group.value + item.sub_group.value,          
        models: item.models == null ? [] : JSON.parse(item.models.value),
        chain_spec: item.chain_spec == null ? null : item.chain_spec.value,
        collection: item.collection == null ? null : {
          id: item.collection.reference.id,
          uri: '/collections/' + item.collection.reference.handle,
          image: item.collection.reference.image == null ? null : item.collection.reference.image.url
        },
      } }))
      if (render.data.metaobjects.pageInfo.hasNextPage) {
        current = await this.loadGroups(render.data.metaobjects.pageInfo.endCursor, current)
      }

      if (startCursor == null) {
        this.loading = false
        this.groupsLastLoaded = Date.now()
        this.groups = current
      } else {
        return current
      }
      
    },
    async getProducts(filter, collection = 'all-products', startCursor = null, results = []) {
      var response = await fetch(this.sitehost + '/api/graphql.json', {
        method: "post",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": this.token
        },
        body: `query getProducts { collection(handle:"` + collection + `") {
          products(first: 25, ` + (startCursor == null ? '': 'after: "' + startCursor + '"') + `, filters: [` + filter + `
            ]) {
              nodes {
                id
                title
                productType
                handle
                featuredImage { url }
                variants(first: 25) {
                  nodes {
                      id
                      sku
                      availableForSale
                      quantityAvailable
                      price { currencyCode amount }
                  }
                }                  
              },
              pageInfo {
                hasNextPage,
                endCursor
              }
            }
          }
        }`})
        
      var render = await response.json()
      if (render.data.collection != null) {
        Array.prototype.push.apply(results, render.data.collection.products.nodes.map((item) => { return {
          id: item.id,
          variant_id: item.variants.nodes[0].id.replace('gid://shopify/ProductVariant/',''),
          variant_id_raw: item.variants.nodes[0].id,
          sku: item.variants.nodes[0].sku,
          in_stock: item.variants.nodes[0].availableForSale,
          quantity: item.variants.nodes[0].quantityAvailable,
          title: item.title,
          product_type: item.productType,
          uri: '/products/' + item.handle,
          image: item.featuredImage == null ? null : item.featuredImage.url,
          price: {
            currency_code: item.variants.nodes[0].price.currencyCode,
            amount: item.variants.nodes[0].price.amount
          },
        } }))
        if (render.data.collection.products.pageInfo.hasNextPage && results.length < 100) {
          results = await this.getProducts(filter, collection, render.data.collection.products.pageInfo.endCursor, results)
        }
      }

      return results
    },
    async getCompatibleChains(chainconfig) {
      var chainQuery = chainconfig.map(c => '{ productMetafield: { namespace:"custom" key: "compatible_chain_configurations" value: "' + c + '" }}').join(', ')
      return await this.getProducts('{ productType:"Chainsaw Chain" }, ' + chainQuery)
    },
    async getCompatibleSprockets(specs = [], group = null) {
      console.log(specs,group)
      var query = [ ...specs.map(c => '{ productMetafield: { namespace:"custom" key: "chain_spec" value: "' + c + '" }}') ]
      return await this.getProducts(query, group + '-sprockets')
    },
    async addItem(variantId, quantity) {
      const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: quantity
          })
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })        
    }      
  },
  persist: { storage: window.localStorage },
})

const defineCustomVueElement = (tagName, component, { plugins = [] } = {}) =>
  customElements.define(tagName, Vue.defineCustomElement(component, {
    //styles: cssIncludes,
    shadowRoot: false,
    configureApp(app) {
      plugins.forEach((plugin) => {
          app.use(plugin)
      })
      app.config.compilerOptions.isCustomElement = (tag) => tag.includes('-')
    }
  }))